export default {
	name: 'bookMangmentImage',
	data() {
		return {
			Edit: '',
			books: [],
			booksName: '',
			bookSate: ['正常', '下架', '借出'],
			BookDetailID: 0,
			BooksID: 0,
			Size: '',
			BooksISBN: '',
			BooksNumCode: '',
			Publisher: '',
			PublicationTime: '',
			BookMoney: 0,
			BookPrice: 0,
			BuyDate: '',
			ShopID: this.$store.state.user.ShopID,
			CurrentPlace: '',
			BooksSate: 0,
			BooksDesc: '',
			OperatorID: this.$store.state.user.UserID,
			getData: {},
			OriginalShopID: 0,
			clear: {},
			pageIndex: 1,
			pageRows: 20,
			count: 0,
			code: ''
		};
	},
	created() {

		this.getData = function() {
			this.BooksID = this.$route.params.booksID;

			this.$request.request({
				url: 'books/getBooksDetail',
				data: {
					pageIndex: this.pageIndex,
					pageCount: this.pageRows,
					BooksID: this.BooksID,
					UserID: this.$store.state.user.UserID,
					areaID: this.$route.params.areaID
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.books = res.BooksDetail;
					this.booksName = "书籍名称:" + res.BooksName;
					this.BooksNumCode = res.BooksNumCode;
					this.code = res.BooksNumCode;
					this.count = res.count;
				}
			});
		}

		this.clear = function() {
			this.BookDetailID = 0;
			this.Size = '';
			this.BooksISBN = '';
			this.Publisher = '';
			this.PublicationTime = '';
			this.BookMoney = '';
			this.BookPrice = '';
			this.BuyDate = '';
			this.CurrentPlace = '';
			this.BooksSate = 0;
			this.BooksDesc = '';
		}

	},
	methods: {

		add() {
			this.clear();
			this.Edit = 'add';
			this.BooksNumCode = this.code;
			this.BookDetailID = 0;
			this.Size = this.books[0].Size;
			this.BooksISBN = this.books[0].BooksISBN;
			this.PublicationTime = this.books[0].PublicationTime;
			this.BookMoney = 0;
			this.BookPrice = 0;
			this.BuyDate = this.books[0].BuyDate;
			this.ShopID = this.$store.state.user.ShopID;
			this.BooksSate = 0;
			this.CurrentPlace = this.books[0].OriginalCurrentPlace;
			this.BooksDesc = '';
			this.Publisher = this.books[0].Publisher;

		},
		updateBookDetail(i) {
			if (this.$store.state.user.UserType != 0 && i.OriginalShopID != this.$store.state.user.ShopID) {
				this.$uil.showMessage({
					text: '非本店书籍不得编辑'
				});
				return;
			}
			this.Edit = 'update';
			this.BookDetailID = i.BookDetailID;
			this.Size = i.Size;
			this.BooksISBN = i.BooksISBN;
			this.BooksNumCode = i.BooksNumCode;
			this.PublicationTime = i.PublicationTime;
			this.BookMoney = i.BookMoney;
			this.BookPrice = i.BookPrice;
			this.BuyDate = i.BuyDate;
			this.ShopID = i.ShopID;
			this.BooksSate = i.BooksSate;
			this.CurrentPlace = i.CurrentPlace;
			this.BooksDesc = '';
			this.OriginalShopID = i.OriginalShopID;
			this.Publisher = i.Publisher;
		},
		editBooksDetail() {
			this.$request.request({
				url: 'books/editBooksDetail',
				data: {
					BooksID: this.BooksID,
					BookDetailID: this.BookDetailID,
					Size: this.Size,
					BooksISBN: this.BooksISBN,
					BooksNumCode: this.BooksNumCode,
					PublicationTime: this.PublicationTime,
					BookMoney: this.BookMoney,
					BookPrice: this.BookPrice,
					BuyDate: this.BuyDate,
					ShopID: this.ShopID,
					CurrentPlace: this.CurrentPlace,
					Publisher: this.Publisher,
					BooksSate: this.BooksSate,
					BooksDesc: this.BooksDesc,
					OperatorID: this.OperatorID,

				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					if (res.result) {
						this.$uil.showMessage({
							text: res.message
						});
						this.clear();
						this.getData();
					}
				}
			});
			this.clear();
			this.Edit = '';
		},
		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;
			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}
			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		}
	},
	computed: {
		showPrice() {
			if (this.Edit == 'add')
				return true;
			else {
				if (this.$store.state.user.UserType == 0)
					return true;
				else {
					if (this.OriginalShopID == this.$store.state.user.ShopID)
						return true;
				}

			}
			return false;

		},
		checkBooks() {
			return this.Size != '' && this.BooksISBN != '' && this.BooksNumCode != '' && this.Publisher != '' && this
				.PublicationTime !=
				'' && this.BookMoney != 0 &&
				this.BookPrice != 0 && this.$uil.checkDate(this.BuyDate) && this.CurrentPlace != '';
		},
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		}
	},
	filters: {

	},
	activated() {
		this.getData();
	},
	watch: {

		$route(n, o) {

			if (n.path.indexOf('booksDetail') == -1) return;
			let nbooksid = n.params.booksID;
			let obooksid = o.params.booksID;
			let nareaID = n.params.areaID;
			let oareaID = o.params.areaID;
			if (nbooksid != obooksid || nareaID != oareaID)
				this.getData();
		}
	}

}
